var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-5" },
    [
      _c("section-title", {
        attrs: {
          content: "Información General del Proponente",
          icon: "fas fa-info",
          reverse: ""
        }
      }),
      _c(
        "div",
        { staticClass: "bg-secondary-3 rounded pr-3 pl-3 mt-5 pb-4 pt-4" },
        [
          _c("div", { staticClass: "row mb-5" }, [
            _c("div", { staticClass: "col-12 col-md-3" }, [
              _c("div", { staticClass: "color-gray-6 font-14" }, [
                _vm._v(" Nombre del Representante Autorizado: ")
              ]),
              _c("div", { staticClass: "color-black font-16" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("empty")(_vm.data.nameAuthorizedRepresentative)
                    ) +
                    " "
                )
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-3" }, [
              _c("div", { staticClass: "color-gray-6 font-14" }, [
                _vm._v(" Correo Electrónico: ")
              ]),
              _c("div", { staticClass: "color-black font-16" }, [
                _vm._v(" " + _vm._s(_vm._f("empty")(_vm.data.email)) + " ")
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-3" }, [
              _c("div", { staticClass: "color-gray-6 font-14" }, [
                _vm._v(" Teléfono: ")
              ]),
              _c("div", { staticClass: "color-black font-16" }, [
                _vm._v(" " + _vm._s(_vm._f("phone")(_vm.data.phone)) + " ")
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-3 mb-3" }, [
              _c("div", { staticClass: "color-gray-6 font-14" }, [
                _vm._v(" Dirección Postal: ")
              ]),
              _c("div", { staticClass: "color-black font-16" }, [
                _vm._v(" " + _vm._s(_vm._f("empty")(_vm.data.address)) + " ")
              ])
            ])
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-md-3" }, [
              _c("div", { staticClass: "color-gray-6 font-14" }, [
                _vm._v(" Tipo de Contratación: ")
              ]),
              _c("div", { staticClass: "color-black font-16" }, [
                _vm._v(
                  " " + _vm._s(_vm._f("empty")(_vm.data.contractType)) + " "
                )
              ])
            ]),
            _c(
              "div",
              {
                staticClass: "col-12 col-md-3",
                class: { "col-md-6": _vm.isProfessionalServices }
              },
              [
                _c("div", { staticClass: "color-gray-6 font-14" }, [
                  _vm._v(" Nombre del Proponente: ")
                ]),
                _c("div", { staticClass: "color-black font-16" }, [
                  _vm._v(
                    " " + _vm._s(_vm._f("empty")(_vm.data.nameProposer)) + " "
                  )
                ])
              ]
            ),
            _vm.isProvisionalRemedyArea
              ? _c("div", { staticClass: "col-12 col-md-3" }, [
                  _c("div", { staticClass: "color-gray-6 font-14" }, [
                    _vm._v(" Seguro social: ")
                  ]),
                  _c("div", { staticClass: "color-black font-16" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("empty")(_vm.data.socialSecurityNo)) +
                        " "
                    )
                  ])
                ])
              : _vm._e(),
            _vm.isProvisionalRemedyArea
              ? _c("div", { staticClass: "col-12 col-md-3 mb-5" }, [
                  _c("div", { staticClass: "color-gray-6 font-14" }, [
                    _vm._v(" Tiempo ofreciendo los servicios: ")
                  ]),
                  _c("div", { staticClass: "color-black font-16" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("empty")(_vm.data.serviceOfferTimeAndTerm)
                        ) +
                        " "
                    )
                  ])
                ])
              : _vm._e(),
            _vm.isProvisionalRemedyArea
              ? _c("div", { staticClass: "col-12 col-md-3" }, [
                  _c("div", { staticClass: "color-gray-6 font-14" }, [
                    _vm._v(" Profesión del Proponente: ")
                  ]),
                  _c("div", { staticClass: "color-black font-16" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("empty")(_vm.data.providerProfession)) +
                        " "
                    )
                  ])
                ])
              : _vm._e(),
            _vm.isProvisionalRemedyArea
              ? _c("div", { staticClass: "col-12 col-md-3" }, [
                  _c("div", { staticClass: "color-gray-6 font-14" }, [
                    _vm._v(" Profesión del Representante: ")
                  ]),
                  _c("div", { staticClass: "color-black font-16" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("empty")(_vm.data.representativeProfession)
                        ) +
                        " "
                    )
                  ])
                ])
              : _vm._e(),
            !_vm.isProvisionalRemedyArea && !_vm.isProfessionalServices
              ? _c("div", { staticClass: "col-12 col-md-3" }, [
                  _c("div", { staticClass: "color-gray-6 font-14" }, [
                    _vm._v(" Número de RUL: ")
                  ]),
                  _c("div", { staticClass: "color-black font-16" }, [
                    _vm._v(
                      " " + _vm._s(_vm._f("empty")(_vm.data.rulNumber)) + " "
                    )
                  ])
                ])
              : _vm._e(),
            !_vm.isProvisionalRemedyArea
              ? _c(
                  "div",
                  { staticClass: "col-12 col-md-3 position-relative mt-n5" },
                  [
                    _c(
                      "div",
                      { staticClass: "bg-white rounded pr-3 pl-3 pb-4 pt-4" },
                      [
                        _vm._m(0),
                        _c(
                          "div",
                          {
                            staticClass: "ml-4",
                            class: `font-${_vm.getAmountFontSize(
                              `${_vm.data.amount}`
                            )}`
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("price")(_vm.data.amount)) +
                                " "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "color-gray-6 font-14" }, [
      _c("i", { staticClass: "fas fa-usd-circle mr-2 text-success h4" }),
      _vm._v(" Monto Total de la Propuesta a Someter: ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }